import { useState } from 'react';
import { trustStats, trustPoints, faqs } from '@/mocks/home';

export default function TrustFaq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="bg-background-50">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-5">
            <p className="text-xs font-label font-medium text-secondary-700 tracking-wide mb-2">
              信任与说明
            </p>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
              为什么这份指南值得看一眼
            </h2>
            <p className="mt-3 text-sm font-label text-foreground-600 leading-relaxed">
              它不生产内容，只做整理：把主播、话题、热门与合集按结构摆好，让你少走弯路、少翻信息流。
            </p>

            <div className="mt-7 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-2 xl:grid-cols-4 gap-3">
              {trustStats.map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg border border-background-200 bg-background-100 px-3 py-4"
                >
                  <p className="font-heading text-xl md:text-2xl font-black text-primary-600 leading-none">
                    {stat.value}
                  </p>
                  <p className="mt-1.5 text-xs font-label text-foreground-600">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-7 space-y-4">
              {trustPoints.map((point) => (
                <div key={point.title} className="flex items-start gap-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-800 shrink-0">
                    <i className={`${point.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h3 className="font-label text-sm font-medium text-foreground-950">{point.title}</h3>
                    <p className="mt-1 text-xs font-label text-foreground-600 leading-relaxed">
                      {point.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-heading text-xl font-bold text-foreground-950">常见问题</h3>
              <span className="text-xs font-label text-foreground-500">共 {faqs.length} 条</span>
            </div>

            <div className="rounded-lg border border-background-200 overflow-hidden">
              {faqs.map((faq, index) => {
                const isOpen = index === openIndex;
                return (
                  <div key={faq.q} className="border-b border-background-200 last:border-b-0">
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? -1 : index)}
                      className="w-full flex items-center gap-4 px-4 md:px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                    >
                      <span
                        className={[
                          'w-7 h-7 shrink-0 flex items-center justify-center rounded-md text-xs font-label font-medium',
                          isOpen
                            ? 'bg-primary-500 text-background-50'
                            : 'bg-background-100 text-foreground-600',
                        ].join(' ')}
                      >
                        {String(index + 1).padStart(2, '0')}
                      </span>
                      <span className="flex-1 font-label text-sm md:text-base font-medium text-foreground-950">
                        {faq.q}
                      </span>
                      <i
                        className={[
                          'text-lg text-foreground-500 transition-transform',
                          isOpen ? 'ri-subtract-line' : 'ri-add-line',
                        ].join(' ')}
                      ></i>
                    </button>
                    {isOpen && (
                      <div className="px-4 md:px-5 pb-5 pl-4 md:pl-16">
                        <p className="text-sm font-label text-foreground-600 leading-relaxed">
                          {faq.a}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="mt-5 rounded-lg border border-secondary-200 bg-secondary-50 px-5 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div className="flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-500 text-background-50 shrink-0">
                  <i className="ri-question-answer-line text-lg"></i>
                </span>
                <p className="text-sm font-label text-secondary-900">
                  还有别的疑问？可以提交内容反馈，我们会跟进。
                </p>
              </div>
              <a
                href="#top"
                className="inline-flex items-center justify-center gap-1.5 h-10 px-5 rounded-md bg-secondary-600 text-background-50 text-sm font-label font-medium hover:bg-secondary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                内容反馈
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}